import { render, staticRenderFns } from "./nearbyShop.vue?vue&type=template&id=65ee88ee&scoped=true&"
import script from "./nearbyShop.vue?vue&type=script&lang=js&"
export * from "./nearbyShop.vue?vue&type=script&lang=js&"
import style0 from "./nearbyShop.vue?vue&type=style&index=0&id=65ee88ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee88ee",
  null
  
)

export default component.exports